import { noop } from 'helpers/noop'
import { useAnalytics } from 'use-analytics'

const useAnalyticsSafe =
  process.env['NODE_ENV'] === 'production' ? useAnalytics : () => ({ track: noop, page: noop, identify: noop })

export { useAnalyticsSafe }
export default useAnalyticsSafe
